import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "system-status-toast" }
const _hoisted_2 = {
  key: 0,
  class: "mdi mdi-loading mdi-spin system-status-toast__spinner"
}
const _hoisted_3 = { class: "system-status-toast__content" }
const _hoisted_4 = {
  key: 0,
  class: "system-status-toast__summary"
}
const _hoisted_5 = { class: "system-status-toast__detail" }
const _hoisted_6 = {
  key: 0,
  class: "loadingSpinner"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Toast = _resolveComponent("Toast")!
  const _component_ConfirmDialog = _resolveComponent("ConfirmDialog")!
  const _component_VerticalNavbar = _resolveComponent("VerticalNavbar")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Toast, {
      position: "bottom-right",
      group: "br"
    }),
    _createVNode(_component_Toast, {
      position: "top-center",
      group: "system-status"
    }, {
      message: _withCtx((slotProps) => [
        _createElementVNode("div", _hoisted_1, [
          (slotProps.message.detail?.showLoader)
            ? (_openBlock(), _createElementBlock("i", _hoisted_2))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_3, [
            (slotProps.message.summary)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(slotProps.message.summary), 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_5, _toDisplayString(slotProps.message.detail?.text ?? slotProps.message.detail), 1)
          ])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_ConfirmDialog),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [...(_cache[2] || (_cache[2] = [
          _createElementVNode("i", {
            class: "mdi mdi-spin mdi-loading",
            style: {"fontSize":"8rem"}
          }, null, -1)
        ]))]))
      : _createCommentVNode("", true),
    (_ctx.route.name && !_ctx.isRouteWithoutLogin() && !_ctx.loading && !_ctx.route.fullPath.includes('system-administration') && !_ctx.embeddedParam)
      ? (_openBlock(), _createBlock(_component_VerticalNavbar, {
          key: 1,
          links: _ctx.navbarLinks,
          hideNavbar: !!_ctx.apiKeyParam,
          onIsUploadDialogShown: _ctx.isUploadDialogShown,
          onOnCollapseSidebar: _cache[0] || (_cache[0] = ($event: any) => (_ctx.opened = !_ctx.opened)),
          onUserLoggedOut: _cache[1] || (_cache[1] = ($event: any) => (_ctx.opened = false))
        }, null, 8, ["links", "hideNavbar", "onIsUploadDialogShown"]))
      : _createCommentVNode("", true),
    (!_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: _normalizeClass({'view-open': _ctx.opened, 'view': !_ctx.isRouteWithoutLogin() && !_ctx.route.fullPath.includes('system-administration') && !_ctx.apiKeyParam && !_ctx.embeddedParam, 'login-background-image': _ctx.isRouteWithoutLogin() && !_ctx.route.fullPath.includes('system-administration')})
        }, [
          _createVNode(_component_router_view, { isUploadShown: _ctx.isUploadShown }, null, 8, ["isUploadShown"])
        ], 2))
      : _createCommentVNode("", true)
  ], 64))
}